/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Termination_TitleInputs */

const en_consumer_declaration_termination_title = /** @type {(inputs: Consumer_Declaration_Termination_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminate a subscription`)
};

const de_consumer_declaration_termination_title = /** @type {(inputs: Consumer_Declaration_Termination_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement kündigen`)
};

const fr_consumer_declaration_termination_title = /** @type {(inputs: Consumer_Declaration_Termination_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résilier un abonnement`)
};

const es_consumer_declaration_termination_title = /** @type {(inputs: Consumer_Declaration_Termination_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar una suscripción`)
};

const it_consumer_declaration_termination_title = /** @type {(inputs: Consumer_Declaration_Termination_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risolvi un abbonamento`)
};

const nl_consumer_declaration_termination_title = /** @type {(inputs: Consumer_Declaration_Termination_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement opzeggen`)
};

const pl_consumer_declaration_termination_title = /** @type {(inputs: Consumer_Declaration_Termination_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wypowiedz subskrypcję`)
};

const fi_consumer_declaration_termination_title = /** @type {(inputs: Consumer_Declaration_Termination_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Irtisano tilaus`)
};

const da_consumer_declaration_termination_title = /** @type {(inputs: Consumer_Declaration_Termination_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opsig et abonnement`)
};

const sv_consumer_declaration_termination_title = /** @type {(inputs: Consumer_Declaration_Termination_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säg upp en prenumeration`)
};

/**
* | output |
* | --- |
* | "Terminate a subscription" |
*
* @param {Consumer_Declaration_Termination_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_termination_title = /** @type {((inputs?: Consumer_Declaration_Termination_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Termination_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_termination_title(inputs)
	if (locale === "fr") return fr_consumer_declaration_termination_title(inputs)
	if (locale === "es") return es_consumer_declaration_termination_title(inputs)
	if (locale === "it") return it_consumer_declaration_termination_title(inputs)
	if (locale === "nl") return nl_consumer_declaration_termination_title(inputs)
	if (locale === "pl") return pl_consumer_declaration_termination_title(inputs)
	if (locale === "fi") return fi_consumer_declaration_termination_title(inputs)
	if (locale === "da") return da_consumer_declaration_termination_title(inputs)
	if (locale === "sv") return sv_consumer_declaration_termination_title(inputs)
	return en_consumer_declaration_termination_title(inputs)
});